import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import MasterAdd from "../../../components/master/MasterAdd";

const MasterBankAdd = ({ buttonConfig, isButtonClicked }) => {
  const schema = z.object({
    name: z.string().nonempty(),
    short_name: z.string(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      eff_end_date: null,
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterAdd
      form={form}
      segmentName={buttonConfig.name}
      addHandler={buttonConfig.addHandler}
      closeHandler={buttonConfig.closeAddModal}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterBankAdd;
